import { useCallback } from 'react';

/** Maps `WorkflowStepsPanel` step ids to `useCompanyContext().navigateTo` tab keys. */
export const WORKFLOW_STEP_ID_TO_TAB: Record<string, string> = {
  transaction: 'transaction',
  individuals: 'individuals',
  compensation: 'compensation',
  baseAmount: 'baseAmount',
  parachute: 'parachute',
  analysis: 'analysis',
  documents: 'documents',
};

export function useNavigateWorkflowStep(navigateTo: (tab: string) => void) {
  return useCallback(
    (stepId: string) => {
      const tab = WORKFLOW_STEP_ID_TO_TAB[stepId];
      if (tab) navigateTo(tab);
    },
    [navigateTo]
  );
}
